import HeaderFull from './HeaderFull';
import HeaderSmall from './HeaderSmall';

const Header = ({ isFullWidth = true, ...rest }: { className?: string; isFullWidth?: boolean }) =>
  isFullWidth ? <HeaderFull {...rest} /> : <HeaderSmall {...rest} />;

export default Header;
